<script setup lang="ts">
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { LessonRecurringModal } from '../../../model/lessons/enums'
import { useLessonRecurringTutor } from '../../../model/lessons/lesson-recurring-tutor.hook'
import LessonRecurringTutor from '../LessonRecurringTutor.vue'

defineOptions({
  name: 'ModalLessonRecurringTutor',
})

const {
  refModal,
  refIsTutorsLoading,
  refHasNoTutors,
  refIsSubmitting,
  confirmTutor,
  confirmBusyTutor,
  backToTutor,
  close,
} = useLessonRecurringTutor()
</script>

<template>
  <ModalDefault
    v-if="refModal === LessonRecurringModal.Tutor"
    show
    class-name="modal-lesson-dialog"
    title="Select tutor to confirm schedule"
    :loading="refIsTutorsLoading || refIsSubmitting"
    @click:overlay="close"
  >
    <div class="modal-lesson-recurring-tutor">
      <LessonRecurringTutor />
    </div>
    <template #controls>
      <div class="modal-lesson-form__controls">
        <BtnPrimary
          text="Confirm schedule"
          color="emerald"
          :disabled="refIsTutorsLoading || refIsSubmitting || refHasNoTutors"
          @click="confirmTutor"
        />
        <BtnSecondary
          text="Cancel"
          color="black"
          :disabled="refIsSubmitting"
          @click="close"
        />
      </div>
    </template>
  </ModalDefault>
  <ModalDefault
    v-else-if="refModal === LessonRecurringModal.Busy"
    show
    class-name="modal-lesson-dialog"
    title="Please mind that some slots are already booked for this tutor"
    description="If you confirm the form submission, some lessons will be created with the tutor but with Planned status. It means that the tutor is busy at this time. You can edit this later for each lesson."
    is-back-button
    :loading="refIsSubmitting"
    @click:back="backToTutor"
    @click:overlay="close"
  >
    <template #controls>
      <div class="modal-lesson-form__controls">
        <BtnPrimary
          text="Confirm"
          color="emerald"
          :disabled="refIsSubmitting"
          @click="confirmBusyTutor"
        />
        <BtnSecondary
          text="Cancel"
          color="black"
          :disabled="refIsSubmitting"
          @click="close"
        />
      </div>
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalLessonForm.scss" />
